module.exports = __webpack_public_path__ + "img/kentaikensa.e5870391.png";